"use client";

import { Button } from "@/components/ui/button";
import { navItems } from "@/config/nav-items";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { Sheet, SheetTrigger } from "./ui/sheet";
import MobileNavbar from "./ui/mobile-navbar";
import { AlignJustify } from "lucide-react";
import { RiTelegram2Line } from "react-icons/ri";
import { BsTwitterX } from "react-icons/bs";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export function NavBar({ ClassName }: { ClassName?: string }) {
  const pathname = usePathname();
  const [isScrolled, setIsScrolled] = useState(false);

  // Check scroll position only when on /vote
  useEffect(() => {
    const handleScroll = () => {
      if (pathname === "/vote") {
        setIsScrolled(window.scrollY > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    // Call immediately in case the page is already scrolled
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  const isSpecialRoute = pathname === "/vote" || pathname === "/docs";
  const bgClass = isSpecialRoute
    ? isScrolled
      ? "bg-indigo-500/65"
      : "bg-transparent"
    : "bg-indigo-500/65";

  return (
    <div className="flex w-full justify-center sticky md:fixed top-0 md:py-1 z-30">
      <nav
        className={cn(
          "md:inline-flex mx-auto items-center hidden bg-transparent transition-all rounded-full justify-center gap-4 px-4 py-2 relative z-10 backdrop-blur-sm",
          bgClass, ClassName 
        )}
      >
        <>
          <Link
            href="/"
            className="text-lime-300 text-2xl inline-flex w-auto font-bold"
          >
            <Image
              src="/logo.png"
              alt="alerts.ai logo"
              className=" inline-flex"
              width={180}
              height={50}
              // className="w-[30%]"
            />
          </Link>
          {/* <div className="flex items-center gap-4 mx-20"> */}
          {navItems.map((item) => {
            const isActive = pathname === item.href;
            return (
              <Link key={item.label} href={item.href}>
                <Button
                  variant="link"
                  className={cn(
                    "text-white bg-transparent font-rubik text-base  font-normal",
                    isActive ? "text-lime-300" : ""
                  )}
                >
                  {item.label === "Buy" && (
                    <Image
                      src="/assests/pump_buy_logo.png"
                      alt="Pump"
                      width={100}
                      height={100}
                      className="w-6 h-6"
                    />
                  )}
                  {item.label}
                </Button>
              </Link>
            );
          })}
          {/* </div> */}

          <div className="flex items-center gap-1">
            <Link
              href={"https://x.com/CatDevAi"}
              className="items-center"
              target="_blank"
            >
              <button className="text-white hover:text-white px-4 py-2 rounded-lg bg-transparent hover:bg-transparent/20">
                <BsTwitterX className="w-5 h-5" />
              </button>
            </Link>
            <Link
              href={"https://t.me/CatDevAi"}
              className="items-center"
              target="_blank"
            >
              <button className="text-white hover:text-white px-3 py-1.5 rounded-lg bg-transparent hover:bg-transparent/20">
                <RiTelegram2Line className="w-7 h-7" />
              </button>
            </Link>
          </div>
        </>
      </nav>

        {/* mobile screens */}
      <div className="z-10 flex p-4 fixed top-0 left-0 justify-between items-center md:hidden bg-indigo-500/80 w-full backdrop-blur-sm">
        <Link
          href="/"
          className="text-lime-300 text-2xl inline-flex w-auto font-bold"
        >
          <Image
            src="/logo.png"
            alt="alerts.ai logo"
            className=" inline-flex w-[70%]"
            width={180}
            height={50}
            // className="w-[30%]"
          />
        </Link>

        <Sheet>
          <SheetTrigger className="md:hidden">
            <AlignJustify className="text-white active:text-neutral-300" size={30} />
          </SheetTrigger>
          <MobileNavbar />
        </Sheet>
      </div>
    </div>
  );
}
